import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const PartnerSvgIcon = styled.div<{ iconPath?: string }>`
    width: 10px;
    height: 10px;
    margin-right: 4px;
    background-color: ${COLORS.GRAY_DARK};
    mask-image: url(${p => p.iconPath});
    mask-size: contain;
    mask-position: center;
    mask-repeat: no-repeat;
    transition: background-color .25s;
`;

export const MenuItemWrapper = styled.li`
    display: flex;
    align-items: center;

    &:not(:last-child) {
        margin-right: 24px;
    }

    a {
        color: ${COLORS.TextHint};
        transition: color .25s;
    }

    &:hover {
        ${PartnerSvgIcon} {
            background-color: ${COLORS.Logo};
        }

        a {
            color: ${COLORS.Logo};
        }
    }
`;

export const PartnerIcon = styled(PartnerSvgIcon)`
    background-color: transparent;
    mask-image: none;

    img {
        width: 100%;
        height: auto;
    }
`;

export const PartnerLink = styled.a`
    ${FONTS.MediumXXS};
    text-decoration: none;
`;
